import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { VersionEvent } from '@angular/service-worker';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

export interface SwUpdateDialogData {
    availableEvent: VersionEvent;
}

@Component({
    selector: 'sphere-sw-update',
    imports: [MatDialogContent, MatDialogTitle, MatDialogActions, MatButton, MatDialogClose],
    template: `
        <h2 mat-dialog-title>Update available</h2>
        <mat-dialog-content>
            <p>
                A new version of Sphere is available, please click below to update to the latest version. Updating will reload the page, make sure
                you've saved your work before reloading.
            </p>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Later</button>
            <button mat-flat-button color="primary" [mat-dialog-close]="true">Update and reload</button>
        </mat-dialog-actions>
    `
})
export class SwUpdateComponent {
    data = inject<SwUpdateDialogData>(MAT_DIALOG_DATA);
}
